/* eslint-disable max-len */

export default {
  lang: 'Spanish',
  homeScreen: {
    title: 'Esto es Anaheim', // Específico del producto
    stayConnected: 'Manténgase conectado',
    comingSoon: 'Próximamente',
    messages: 'Mensajes',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Vamos a ver si podemos encontrar un perfil existente para usted en nuestro sistema.',
      homeTitleSub:
        'Introduzca la dirección de correo electrónico que utiliza habitualmente para acceder a los programas de formaci',
      noAccount:
        'No se ha encontrado ninguna cuenta ({email}), inténtalo con otra dirección de correo electrónico o crea una cuenta ahora.',
      continueButton: 'Continuar',
      success:
        'Ha actualizado correctamente su cuenta. En breve será redirigido a la página de inicio.',
      successNewAccount:
        'Para completar su inscripción, recibirá un correo electrónico de confirmación para verificar su cuenta.',
      loginButton: 'Inicio de sesión',
      matchFound:
        'Hemos encontrado una coincidencia, por favor, introduzca su contraseña para continuar.',
      magicLink:
        'Inicie sesión a través de un enlace en su correo electrónico:',
      magicLinkButton: 'Solicitar Magic Link',
      magicLinkTitle:
        'Recibe un enlace directo en tu correo electrónico que te permitirá registrarte al instante.',
      otherEmailButton: 'Enviar',
      title:
        'Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.',
      titleIndustry:
        'Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.',
      register: 'Crear una cuenta',
      agent: 'Asesor de viajes',
      visitor: 'Visitante del sector',
      step1: 'Paso 1: Tipo de usuario',
      step2: 'Paso 2: Crear una cuenta',
      step3: 'Paso 3: Cree su perfil',
      marketingOptIn:
        '¿Está seguro de que no le interesa seguir vinculado al equipo de comercio de viajes de este programa?',
      optIn: 'Sí, me interesa',
      optOut: 'No me interesa',
      step2Sub1: 'Háblenos de usted',
      step2Sub2: 'Háblenos de su empresa',
      privacyHead: 'PREFERENCIAS DE COMUNICACIÓN',
      privacySub:
        'Marque las casillas que aparecen a continuación para asegurarse de que recibe comunicaciones importantes del equipo comercial de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAMs, etc.) e iniciativas de redes comerciales de viajes y apoyo a las ventas de TravPRO Mobile.',
      privacy:
        'Protegemos su privacidad y nunca vendemos, abusamos o traicionamos su confianza.',
      store: 'Descarga fácilmente este programa en tu tienda de aplicaciones:',
      powered: 'PODER DE',
      toastMessage: {
        forgotSuccess:
          'Le hemos enviado por correo electrónico un enlace para restablecer su contraseña. Serás redirigido a la página de inicio de sesión en 10 segundos.',
        emailNotExisting:
          'La dirección de correo electrónico que has introducido no existe.',
        magicLinkMessage:
          'Por favor, espera, te estamos registrando ahora mismo.',
        magicLinkError:
          'No hemos podido encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Será redirigido en 10 segundos.',
        magicLinkError1:
          'No hemos podido encontrar un token válido, por favor inicie sesión o solicite un nuevo enlace mágico. Si este problema persiste, póngase en contacto con nosotros en: info@travpromobile.com.',
        magicLinkError2:
          'No hemos podido encontrar su cuenta en nuestra base de datos, por favor inicie sesión manualmente. Será redirigido en 10 segundos.',
        magicLinkSuccess:
          'Comprueba tu correo electrónico en {email}. Tiene un enlace mágico que te registrará.',
        magicLinkErrorWait:
          'Por favor, espera 5 minutos entre peticiones de enlace mágico.',
        emailNotFoundError:
          'La dirección de correo electrónico que ha introducido no se encuentra en nuestros registros. Por favor, compruebe si hay errores ortográficos o cree una cuenta.',
      },
      errors: {
        zipCodeNotFound: 'Código postal no encontrado, inténtelo de nuevo',
        zipCodeOnlyNumbers: 'El código postal sólo puede contener números',
        password: 'Introduzca una contraseña',
        passwordNotMatching: 'Las contraseñas introducidas no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        emailExists:
          'Esta dirección de correo electrónico ya existe o no es válida. Inténtelo con otra dirección de correo electrónico o acceda a su cuenta.',
        fillInAllFields: 'Rellene todos los campos obligatorios',
        fillInEmail:
          'Por favor, introduzca su dirección de correo electrónico.',
        emailNotExisting:
          'La dirección de correo electrónico que ha introducido no existe.',
      },
      fields: {
        forgotSubCopy: '¿Has olvidado tu contraseña y quieres cambiarla? ',
        forgotSubCopy2:
          '¿Quiere saltarse la contraseña por completo? Le enviaremos un correo electrónico con un enlace mágico que le permitirá acceder automáticamente al programa. ',
        city: 'Ciudad',
        companyName: 'Nombre de la empresa',
        role: 'Su función',
        description: '¿Cuál describe mejor la actividad de su empresa?',
        country: 'País',
        password: 'Contraseña',
        passwordRegister: 'Elija una contraseña (mínimo 8 caracteres)',
        passwordConfirm: 'Confirmar contraseña',
        firstName: 'Nombre',
        lastName: 'Apellido (Familia)',
        agency: 'Nombre de su agencia',
        title: 'Su función (seleccione una)',
        company: 'Nombre de la empresa',
        select: 'Seleccione una opción',
        state: 'Estado',
        province: 'Provincia/Región/Estado',
        zipCode: 'Código postal',
        postalCode: 'Código postal',
        affiliate: '¿A qué grupo está afiliada su agencia PRINCIPAL?',
        hostAgency: '¿Su agencia de acogida?',
        executive: 'Ejecutivo',
        management: 'Gestión',
        marketing: 'Marketing',
        sales: 'Ventas',
        coordinator: 'Coordinador',
        opt: 'Manténgase en contacto con el equipo de comercio de viajes de este programa y reciba actualizaciones.',
        optMarketing:
          'Manténgase en contacto con TravPRO en relación con programas y eventos similares.',
        retail: 'Fachada de tienda',
        home: 'Agente a domicilio',
        independent: 'Contratista independiente',
        host: 'Organismo anfitrión',
        call: 'Centro de llamadas o agencia web',
        other: 'Otros',
        describes:
          '¿Qué es lo que mejor describe su actividad y la de su agencia?',
      },
    },
    title:
      'Programa de Capacitación y Facilitación de Ventas para Profesionales de Viajes', // Específico del producto (texto TravPRO o ChannelPRO)
    welcome: {
      headerTop: 'Bienvenido a',
      headerBottom: 'Anaheim Specialist Sales Companion', // Específico del producto
    },
    sellingPoints: {
      // Todos los puntos de venta pueden ser específicos del producto
      0: 'Aprenda, Promueva y Venda en Movimiento',
      1: 'Capacitación Multimedia en Todos los Dispositivos',
      2: 'Certificado de Finalización',
      3: 'Presentaciones de Ventas Preparadas',
      4: 'Materiales Promocionales de Alto Impacto',
      5: 'Consejos y Promociones Exclusivas',
      6: 'Directorio de Productos en Tiempo Real',
      7: 'Noticias y Actualizaciones Oportunas',
    },
    emailPrompt:
      'Ingrese su dirección de correo electrónico y contraseña para confirmar que es un profesional de viajes.', // Específico del producto (texto TravPRO o ChannelPRO)
    tAndC: {
      agree: 'Al continuar, acepta nuestra ',
      privacyPolicy: 'política de privacidad',
      and: ' y ',
      termsConditions: 'términos y condiciones',
    },
    fields: {
      what: '¿Qué tipo de viajes vende?',
      what1: '¿Cuál es el tipo de viaje n.° 1 que vende?',
      what2: '¿Cuál es el tipo de viaje n.° 2 que vende?',
      what3: '¿Cuál es el tipo de viaje n.° 3 que vende?',
      agency: 'Agencia *',
      email: 'Correo electrónico',
      password: 'Contraseña *',
      passwordConfirm: 'Confirmar su contraseña *',
      firstName: 'Nombre *',
      lastName: 'Apellido *',
      agencyName: 'Nombre de la Agencia *',
      city: 'Ciudad *',
      stateProvince: 'Estado / Provincia *',
      salutation: 'Tratamiento *',
      required: 'Obligatorio',
      invalidEmail: 'Dirección de correo electrónico no válida',
      opt: 'Manténgase en contacto. Sí, me gustaría recibir comunicaciones de Visit Anaheim que me mantendrán informado sobre noticias, eventos, incentivos, FAM y mucho más.',
      complete: 'Paso 2: Complete su perfil',
      tell: 'Háblenos de usted',
      title: 'Cargo Empresarial *',
      host: 'Nombre de la Agencia Anfitriona',
      country: 'País / Región',
      select: 'Seleccione una opción a continuación',
      header2: '¿Qué segmento(s) vende principalmente?',
      step2: 'Describa Su Empresa',
      leisure: 'Ocio',
      corporate: 'Empresarial',
      group: 'Grupo',
      affiliate: '¿Cuál es su Principal Afiliación?',
      forgot:
        '¿Ha olvidado su contraseña? Haz clic en el botón de abajo y te enviaremos un correo electrónico para restablecer tu contraseña.',
    },
    forgot: 'Restablecer contraseña',
    noAgent: {
      noAgentButton: 'No soy asesor',
      title: 'Gracias por su interés en Visit Anaheim.', // Producto específico
      messageWeb:
        'El contenido de este sitio es exclusivo para profesionales de viajes. \n Para obtener más información sobre Anaheim, visite:', // Producto específico
      messageMobile:
        "Algunos contenidos de esta aplicación son exclusivos para profesionales de viajes, pero siéntase libre de navegar una vista previa de lo que esta aplicación tiene para ofrecer presionando 'Continuar'.", // Producto específico
      continue: 'Continuar',
      visitWebsite: 'Visitar sitio web',
    },
    newUser: 'Nuevo Usuario',
    register: 'Registrar',
    registered: 'Este correo electrónico ya está registrado',
    forgot: 'Olvidé mi contraseña',
    header:
      'Por favor, tome un momento para completar toda la información a continuación, ya que esto es lo que llenará su perfil y la información de contacto.',
    step1:
      'Paso 1: Complete su dirección de correo electrónico y elija una contraseña.',
  },
  welcomeScreen: {
    title: 'Bienvenido a Especialista de Anaheim', // Producto específico
    helloUser: 'Hola {{name}}',
    hello: 'Hola,',
    fromAgency: 'de {{agency}}',
    notUser: '¿No eres {{name}}?',
    introOnline:
      '¡Entrene inmediatamente en línea o cargue el contenido para que esté siempre disponible para uso sin conexión!',
    introOffline:
      'Ya tiene la última versión precargada. ¡Comience a capacitarse o vender en cualquier momento y lugar y desde cualquier dispositivo!',
    startTraining: 'Comenzar a aprender',
    continueTraining: 'Continuar aprendiendo',
    graduated: '¡Felicidades!',
    downloader: {
      preload: 'Precarga',
      stop: 'parar',
      init: 'Inicializando...',
      lastUpdate: 'Última actualización: ',
    },
  },
  trainingScreens: {
    start: 'Comenzar',
    continue: 'Continuar',
    review: 'Revisar',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number}% Completo',
    unlock:
      'Desbloquea este capítulo completando el capítulo de entrenamiento {number}.',
    unlockSubtitle:
      'Desbloquea más capítulos completando capítulos de entrenamiento.',
    allUnlocked: '¡Has desbloqueado todos los capítulos!',
    certificate: 'Certificado',
    courseComplete: 'Continuar',
    endReached: '¡Has llegado al final!',
    retainEnd:
      'Utilice la barra superior para navegar por este capítulo o presione el botón de retroceso para volver a la vista general.',
    watchListenRead: 'Mire, Escuche y Lea más',
    trouble:
      'Parece que está teniendo problemas, por favor vuelva a leer el contenido en la(s) página(s) anterior(es) y vuelva a intentarlo.',
    confirm: 'Confirme su respuesta',
    choose: 'Por favor, elija una respuesta',
    skip: 'Volver >',
    viewAllTitle: 'Consejo de Entrenamiento',
    viewAll:
      'Para avanzar a la siguiente página, haga clic en los iconos para ver el contenido complementario. Se han proporcionado videos, mapas y otra información útil para mejorar su entrenamiento y asegurarse de que alcance el estado de PRO.',
    fillBlanks: 'Rellenar los espacios en blanco:',
    next: 'Siguiente pregunta',
    retry: 'Intentar de nuevo',
    fastTrackText: {
      success:
        '¡Felicitaciones, ha aprobado el curso Fast Track y ha desbloqueado el resto del entrenamiento!',
      failed:
        'Desafortunadamente, no aprobó el curso Fast Track. ¡Puede continuar su entrenamiento para obtener su diploma!',
    },
    fastTrack: '¡Conviértete en un Superestrella de Viajes por Suiza!',
    fastTrackExplanation:
      'Simplemente responda el cuestionario en las páginas siguientes para tener la oportunidad de ganar un FAM a Suiza. <br><br><span style = "font-weight: bold"> Encontrará todas las respuestas a las preguntas del cuestionario de las siguientes maneras:</span><br><br>1. El contenido que aprendió en los módulos de Rail Europe y Suiza.<br><br>2. Y en los siguientes sitios web: <br> <a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a> <br> <a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a> <br> <a href="https://www.mysts.net" target="_blank">www.mysts.net</a> <br><br> <span style = "font-weight: bold"> ¡Asegúrese de revisar estos recursos en detalle antes de tomar el cuestionario! Solo aquellos con las mejores calificaciones tendrán la oportunidad de ser invitados al FAM. </span>',
    fastTrackButton:
      'Haga clic aquí para tomar el cuestionario de Superestrella Suiza',
    grading: 'Su calificación final es: {grade}%',
  },
  nav: {
    home: 'Inicio',
    train: 'Aprender',
    learn: 'Aprender',
    retain: 'Mantener',
    directory: 'Directorio',
    showRoom: 'Mostradores',
    showcases: 'Mostradores',
    offers: 'Ofertas',
    promote: 'Promover',
    sell: 'Vender',
    info: 'Información',
    rewards: 'Recompensas',
    media: 'Multimedia',
    favorites: 'Favoritos',
    contact: 'Conoce al Equipo',
    reportCard: 'Ver diploma',
    accountSettings: 'Configuración de cuenta',
    messages: 'Mensajes',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Aprender',
    retain: 'Mantener',
    subapps: 'Módulos para Socios de Anaheim',
    maintrainings: 'La Base',
    subtrainings: 'La Experiencia',
  },
  pageDescriptions: {
    train: 'Educar, involucrarse y convertirse en el experto.',
    showroom: '',
    retain:
      ' Su recurso para retener su conocimiento experto y habilitar sus esfuerzos de ventas. Use esta área para responder expertamente una pregunta sobre un producto o incluso como una presentación de ventas improvisada, en cualquier momento, en cualquier lugar y desde cualquier dispositivo.',
    promote: 'Inicie la conversación con sus clientes y prospectos.',
    sell: 'Responda preguntas de clientes y cierre la venta.',
    favorites: 'Consulte su contenido personalmente favorito',
    search: 'Busque en todo el contenido',
    subapps: '',
    maintrainings:
      'Complete estos módulos esenciales para obtener su certificado.',
    subtrainings:
      'Complete estos módulos sobre todas las cosas increíbles que los clientes pueden hacer y ver en Anaheim y reciba su certificado como Especialista oficial de Anaheim.',
  },
  general: {
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Ver {type}',
    imageNotFound: 'Imagen no encontrada',
    noResultsFor: 'No se han encontrado resultados para: {{query}}',
    noFavorites: 'Aún no tienes favoritos.',
    noMessages: '¡Todavía no has recibido ningún mensaje!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar todo',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: '¡Página 404 no encontrada!',
    oops: '¡Ups!',
    overview: 'Volver a la visión general',
    complete: 'Continuar',
    courseComplete: '¡Capítulo completado!',
    chapterComplete: '¡Capítulo completado!',
    message: '{count} Mensaje',
    messagePlural: '{count} Mensajes',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Colección',
    layout: 'Diseño',
    web: 'Sitio web',
    pdf: 'PDF',
    carousel: 'Colección',
  },
  questions: {
    dials: 'Gire los diales para que coincidan con la respuesta',
    fitb: 'Complete el o los espacios en blanco',
    flip: 'Cambie el número para que coincida con la respuesta',
    multipleChoice: 'Seleccione la(s) respuesta(s) correcta(s)',
    slider: 'Seleccione la respuesta correcta utilizando el control deslizante',
    map: 'Responda la pregunta tocando la ubicación correcta en el mapa',
    dropdown: 'Elija...',
    true: 'Verdadero',
    false: 'Falso',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo electrónico',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Optar por no participar',
    settings: 'Configuración de privacidad',
    message:
      '¡No nos has contado nada sobre tus preferencias de privacidad de datos! No hay problema, pero nos gustaría ofrecerte la mejor experiencia utilizando Sales Companion.',
    disabled: 'Parece que has deshabilitado el uso de cookies.',
    use: 'Sales Companion requiere el uso de cookies para brindarte la mejor experiencia.',
    details: '¿Para qué se usan las cookies?',
    enable: 'Ver cómo habilitar tus cookies {{here}}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No has iniciado sesión',
    title: 'Debes iniciar sesión para ver este contenido',
    guest: 'Invitado',
  },
  demo: {
    message:
      'Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.',
    consent: '¡Entendido!',
  },
  share: {
    header: '¡Comparte este recurso en tus redes sociales favoritas!',
    download: 'Descargar',
  },
  sharing: {
    copyURL: 'Copiar enlace',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header:
      'Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil',
    body: 'Para descargar este programa, simplemente visita tu tienda de aplicaciones y busca {appName} o haz clic en uno de los botones a continuación',
    benefits: {
      header: 'Esto te proporcionará:',
      1: 'Aprender, promocionar y vender sobre la marcha',
      2: 'Capacitación multimedia en diferentes dispositivos',
      3: 'Certificado de finalización',
      4: 'Presentaciones de ventas listas para usar',
      5: 'Materiales promocionales de alto impacto',
      6: 'Directorio de productos en tiempo real',
      7: 'Noticias y actualizaciones oportunas',
    },
  },
  directoryView: {
    search: 'Buscar...',
    amountOfResults: 'Cantidad de resultados:',
    filter: 'Filtrar',
    filters: 'Filtros:',
    resetFilters: 'Restablecer filtros',
    showResults: 'Mostrar resultados',
    noResults:
      'No se encontraron resultados. Por favor, intenta con una búsqueda diferente.',
    resetMap: 'Restablecer mapa al inicio >',
    viewNow: 'Ver ahora >',
  },
  directory: {
    artsentertainment: 'Artes y entretenimiento',
    conventionservices: 'Servicios de convenciones',
    divingsnorkeling: 'Buceo y snorkel',
    film: 'Películas',
    fitlauderdale: 'FitLauderdale',
    hotels: 'Hoteles',
    lgbtgymsandspas: 'LGBT+: Gimnasios y spas',
    lgbtshopping: 'LGBT+: Compras',
    lgbtwheretostay: 'LGBT+: Dónde alojarse',
    multiculturaldining: 'Multicultural: Comida',
    multiculturalnightlife: 'Multicultural: Vida nocturna',
    nightlife: 'Vida nocturna',
    petfriendly: 'Aceptan mascotas',
    restaurants: 'Restaurantes',
    shopping: 'Compras',
    spas: 'Spas',
    transportation: 'Transporte',
    sports: 'Deportes',
    venues: 'Lugares',
    waterways: 'vías navegables',
    waystoplay: 'Formas de jugar',
    weddinglocations: 'Lugares de bodas',
    weddingvendors: 'Vendedores de bodas',
    accommodations: 'Alojamientos',
    attractions: 'Atraccioness',
    tourtransport: 'Tour y Transporte',
    transportation: 'Tour y Transporte',
    dining: 'Comida',
    attractionsactivities: 'Atraccioness',
  },
  costumbre: {
    splitUsers: 'Soy un...',
    brandAmbassador: 'Embajador de la marca',
    travelPro: 'Profesional de viajes',
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};
